<template>
  <div class="unsub-page">
    <div class="unsub-shell">
      <img class="unsub-logo" :src="logoSrc" alt="Saludsa Refiere y Gana" />

      <h2 class="unsub-title">Cancelar suscripción</h2>

      <p v-if="status === 'loading'" class="unsub-subtitle">
        Desactivando suscripción...
      </p>
      <p v-else-if="status === 'success'" class="unsub-subtitle">
        Has desactivado correctamente la suscripción a las notificaciones por
        correo electrónico. Ya no recibirás mensajes en
        <strong>{{ email }}</strong
        >.
      </p>

      <div
        v-if="status === 'success'"
        class="unsub-check-wrap"
        role="img"
        aria-label="Desuscripción confirmada"
      >
        <span class="unsub-check-ring" aria-hidden="true">
          <i class="fas fa-check unsub-check-mark"></i>
        </span>
      </div>
      <p v-else class="unsub-subtitle">
        {{ errorMessage }}
      </p>

      <div
        v-if="status === 'loading'"
        class="unsub-spinner"
        aria-hidden="true"
      ></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import logoSrc from "@/assets/img/Saludsa/logo_new_saludsa_vertical.png";

export default {
  name: "Desuscribirse",
  data() {
    return {
      status: "loading", // loading | success | error
      email: "",
      errorMessage: "",
      logoSrc,
    };
  },
  async mounted() {
    const token = String(this.$route.query.token || "").trim();
    if (!token) {
      this.status = "error";
      this.errorMessage = "Falta token de desuscripción.";
      return;
    }

    try {
      const res = await this.$https.get("/mailing/unsubscribe", {
        params: { token, format: "json" },
      });
      if (res.data && res.data.ok) {
        this.status = "success";
        this.email = res.data.email || "";
      } else {
        this.status = "error";
        this.errorMessage = "Token inválido o expirado.";
      }
    } catch (err) {
      const code = err?.response?.status;
      if (code === 404) this.errorMessage = "Token inválido o expirado.";
      else this.errorMessage = "Error procesando desuscripción.";
      this.status = "error";
    }
  },
};
</script>

<style scoped>
.unsub-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 16px;
  background: #f3f6ff;
}

.unsub-shell {
  width: 100%;
  max-width: 520px;
  text-align: center;
  background: transparent;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.unsub-logo {
  width: 220px;
  height: auto;
  object-fit: contain;
  margin: 0 auto 28px;
  display: block;
}

.unsub-title {
  font-weight: 800;
  font-size: 22px;
  margin: 4px 0 20px;
  color: #111827;
  line-height: 1.25;
}

.unsub-check-wrap {
  margin: 30px auto 0;
}

.unsub-check-ring {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  background: rgba(16, 185, 129, 0.09);
  border: 1px solid rgba(5, 150, 105, 0.18);
}

.unsub-check-mark {
  font-size: 15px;
  color: #0f766e;
  line-height: 1;
  opacity: 0.88;
}

.unsub-subtitle {
  margin: 0 auto;
  color: #6b7280;
  font-size: 13px;
  line-height: 18px;
  max-width: 460px;
}

.unsub-spinner {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid rgba(16, 185, 129, 0.2);
  border-top-color: rgba(5, 150, 105, 0.55);
  margin: 24px auto 0;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
